import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import ReactSelect from 'react-select'

import { BranchMixin } from 'legacy/libs/baobab-react-mixins'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'

import createReactClass from 'create-react-class'

export default createReactClass({
  displayName: 'Select',

  mixins: [BranchMixin, FormComponentMixin],

  propTypes: {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func,
  },

  cursors(props, context) {
    return {
      value: this.getCursor(props, context),
    }
  },

  getDefaultProps() {
    return {
      onChange: _.identity,
    }
  },

  onValueChange(item) {
    const value = _.result(item, 'value', null)
    const previousValue = this.state.value

    // if (this.props.hideResetButton && value === null) {
    //     return;
    // }

    if (value === previousValue) {
      return
    }

    this.setDirtyState()
    this.setValue(value, () => this.props.onChange(value, previousValue))
  },

  render() {
    const options = _.map(this.props.options, (option) => ({
      ...option,
      label: option.label || '',
    }))
    const initialValue = _.find(this.props.options, (option) =>
      _.isEqual(option.value, this.state.value)
    )

    return (
      <ReactSelect
        options={options}
        value={initialValue}
        onChange={this.onValueChange}
        isLoading={this.props.isLoading}
      />
    )
  },
})
